import * as THREE from 'three';

const wallTextureLoader = new THREE.TextureLoader();

export const addTextureToWalls = (textureUrl: string, roomModel: any, callback: Function) => {
    // Load the texture and assign it to the mesh material
    
    wallTextureLoader.load(textureUrl, wallTexture => {
        wallTexture.repeat.set(10, 10);
        wallTexture.wrapS = wallTexture.wrapT = THREE.MirroredRepeatWrapping;
        roomModel.traverse((child: any) => {
            if (child.isMesh && child.material.name.indexOf('Wall') != -1) {
                child.material.map = wallTexture;
                child.material.needsUpdate = true;
            }
        });
        callback();
    });
}

export const getDefaultWallTexture = () => {
    return "sprayed-wall-texture1_albedo_optimized"; //"defaultWallTexture"
}
export const getDefaultWallNormalTexture = () => {
    return "sprayed-wall-texture1_normal-ogl_optimized"; //"defaultWallTexture";
}

export const getDefaultWallColor = () => {
    return "C2BCb5";
}